import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {WordForm} from "../forms";
import {internalDictionaryService} from "../../services";
import {arrays, forms, strings} from "@atttomyx/shared-utils";

const toData = (word) => {
    let definition1 = null;
    let definition2 = null;
    let definition3 = null;
    let sentence1 = null;
    let sentence2 = null;
    let sentence3 = null;

    if (word.definitions) {
        definition1 = word.definitions.length > 0 ? word.definitions[0] : null;
        definition2 = word.definitions.length > 1 ? word.definitions[1] : null;
        definition3 = word.definitions.length > 2 ? word.definitions[2] : null;
    }

    if (word.sentences) {
        sentence1 = word.sentences.length > 0 ? word.sentences[0] : null;
        sentence2 = word.sentences.length > 1 ? word.sentences[1] : null;
        sentence3 = word.sentences.length > 2 ? word.sentences[2] : null;
    }

    return {
        word: word.word,
        definition1: definition1,
        definition2: definition2,
        definition3: definition3,
        sentence1: sentence1,
        sentence2: sentence2,
        sentence3: sentence3,
        ai: !word.id,
        valid: strings.isNotBlank(word.word) && word.word.length >= 3 && word.word.length <= 6
            && (!word.id
                || (word.id && strings.isNotBlank(definition1)
                    && strings.isNotBlank(sentence1) && strings.isNotBlank(sentence2) && strings.isNotBlank(sentence3))),
    }
};

const WordDialog = (props) => {
    const { snackbar, word, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(word));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        const success = (saved) => {
            snackbar.setSuccess(saved.word + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        setSaving(true);

        if (data.ai) {
            internalDictionaryService.createWord(data.word, success, failure);

        } else {
            const definitions = [data.definition1];

            if (strings.isNotBlank(data.definition2)) {
                arrays.addTo(definitions, data.definition2);
            }

            if (strings.isNotBlank(data.definition3)) {
                arrays.addTo(definitions, data.definition3);
            }

            const info = {
                word: data.word,
                definitions: definitions,
                sentences: [data.sentence1, data.sentence2, data.sentence3],
            };

            internalDictionaryService.saveWord(info, success, failure);
        }
    };

    return <Dialog
        open={true}
        aria-labelledby="word-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Word
        </ClosableDialogTitle>
        <DialogContent className="word-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <WordForm
                    data={data}
                    onChange={setData}
                    allowAi={!word.id}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button
                color="primary"
                disabled={!data.valid || !forms.differ(toData(word), data)}
                onClick={submitForm}
            >
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default WordDialog;
